export const maxWidth = 1170
export const mobileMenuMaxWidth = 1130
